import { Context } from '@vue-storefront/core';

export default async function shopConfig({ client, config }: Context, name: string): Promise<string> {
  const url = new URL('/mall/shop-config/get', config.api.url);

  const { data: res } = await client.post(url.href, { name });

  return String(res?.data?.data) || '';
}
